import appConfig from "../config/appConfig";
import { Role } from "../context/userinfo/types";
import { tenantEnv } from "./utils";

const viteBase = import.meta.env.BASE_URL;
export const BASE_URL: string = viteBase === "/" ? "" : viteBase.replace(/\/$/, "");

export const FALLBACK_LOGO_URL = `${BASE_URL}/fallback-logo.png`;

export const DASHBOARD_LOGO_URL = `${BASE_URL}/dashboard-logo.ico`;

export const FINTECH_PRIMITIVES_LOGO_URL = `${BASE_URL}/fp-badge.svg`;

export const NOT_FOUND_IMAGE_URL = `${BASE_URL}/not-found.svg`;

export const AUTH_REDIRECT_URI = window.location.origin + BASE_URL;

const oldDashboardLinkEnvMap = {
  production: "https://dashboard.fintechprimitives.com/",
  sandbox: "https://sandbox.dashboard.fintechprimitives.com/",
  staging: "https://development.dashboard.fintechprimitives.com/", // TODO Check if this is correct
  qa: "-",
};

export const OLD_DASHBOARD_LINK = oldDashboardLinkEnvMap[tenantEnv.getEnvironmentName()];

export const OLD_DASHBOARD_PROD_DISASTER_RECOVERY_LINK =
  "https://dashboard-dr.fintechprimitives.com/";

export const CAMS_FUNDSNET_LOGIN_URL = "https://fundsnet.camsonline.com/ecrms/index.aspx";
export const KFin_FUNDSNET_CHANNEL_PARTNERS_LOGIN_URL =
  "https://cpupload.kfintech.com/ChannelServices/CP_Login.aspx";
export const KFin_FUNDSNET_RIA_LOGIN_URL =
  "https://cpupload.kfintech.com/ChannelServices/RIA_Login.aspx";
export const INTERNAL_USER_EMAIL_DOMAIN = "cybrilla";

const orderSubmissionAvoLinkEnvMap = {
  production: "https://dashboard.fintechprimitives.com/live/resources/order_submissions",
  sandbox: "https://sandbox.dashboard.fintechprimitives.com/sandbox/resources/order_submissions",
  staging: "https://development.dashboard.fintechprimitives.com/resources/order_submissions", // TODO Check if this is correct
  qa: "-",
};
export const ORDER_SUBMISSION_AVO_URL =
  orderSubmissionAvoLinkEnvMap[tenantEnv.getEnvironmentName()];

const thirdeyeUrlWebOriginEnvMap = {
  production: "http://{{realm}}.thirdeye.fpapps.io",
  sandbox: "http://{{realm}}.thirdeye.s.finprim.com",
  staging: "http://{{realm}}.thirdeye.d.finprim.com", // TODO Check if this is correct
  qa: "-",
};
export const THIRDEYE_URL_WEB_ORIGIN = thirdeyeUrlWebOriginEnvMap[tenantEnv.getEnvironmentName()];

const thirdeyePostLogoutRedirectUrlEnvMap = {
  production: "http://{{realm}}.thirdeye.fpapps.io/login",
  sandbox: "http://{{realm}}.thirdeye.s.finprim.com/login",
  staging: "http://{{realm}}.thirdeye.d.finprim.com/login", // TODO Check if this is correct
  qa: "-",
};
export const THIRDEYE_POST_LOGOUT_REDIRECT_URL =
  thirdeyePostLogoutRedirectUrlEnvMap[tenantEnv.getEnvironmentName()];

const thirdeyeRedirectUrlEnvMap = {
  production: "http://{{realm}}.thirdeye.fpapps.io/oauth-authorized/{{realm}}",
  sandbox: "http://{{realm}}.thirdeye.s.finprim.com/oauth-authorized/{{realm}}",
  staging: "http://{{realm}}.thirdeye.d.finprim.com/oauth-authorized/{{realm}}", // TODO Check if this is correct
  qa: "-",
};
export const THIRDEYE_REDIRECT_URL = thirdeyeRedirectUrlEnvMap[tenantEnv.getEnvironmentName()];

const internalThirdeyeSetupRedirectUrlEnvMap = {
  production: ["http://{{realm}}.thirdeye.fpapps.io/oauth-authorized/fp-apps"],
  sandbox: ["http://{{realm}}.thirdeye.s.finprim.com/oauth-authorized/fp-apps"],
  staging: ["http://{{realm}}.thirdeye.d.finprim.com/oauth-authorized/fp-apps"], // TODO Check if this is correct
  qa: ["-"],
};
export const INTERNAL_THIRDEYE_SETUP_REDIRECT_URL =
  internalThirdeyeSetupRedirectUrlEnvMap[tenantEnv.getEnvironmentName()];

const internalThirdeyeSetupPostLogoutRedirectUrlEnvMap = {
  production: "http://{{realm}}.thirdeye.fpapps.io/*",
  sandbox: "http://{{realm}}.thirdeye.s.finprim.com/*",
  staging: "http://{{realm}}.thirdeye.d.finprim.com/*", // TODO Check if this is correct
  qa: "-",
};
export const INTERNAL_THIRDEYE_SETUP_POST_LOGOUT_REDIRECT_URL =
  internalThirdeyeSetupPostLogoutRedirectUrlEnvMap[tenantEnv.getEnvironmentName()];

export const DASHBOARD_WIAM_REDIRECT_URL = window.location.origin + BASE_URL;
export const DASHBOARD_WIAM_CLIENT_ID = tenantEnv.isProduction ? "fp-apps-live" : "fp-apps-test";
export const DASHBOARD_WIAM_CLIENT_NAME = "FP Dashboard";
export const FP_OPS_PORTAL_WIAM_CLIENT_ID = tenantEnv.isProduction
  ? "fp-ops-portal-live"
  : "fp-ops-portal-test";
export const FP_OPS_PORTAL_WIAM_CLIENT_NAME = "FP OPS Portal";
export const THIRDEYE_WIAM_CLIENT_ID = "thirdeye";
export const THIRDEYE_WIAM_CLIENT_NAME = "Thirdeye";
export const DASHBOARD_BACKEND_CLIENT_ID = tenantEnv.isProduction
  ? "fp-dashboard-live"
  : "fp-dashboard-test";
export const DASHBOARD_BACKEND_CLIENT_NAME = "Fp Dashboard Backend Client";
const thirdeyeNavigationUrlEnvMap = {
  production: "https://{{realm}}.thirdeye.fpapps.io/login/",
  sandbox: "https://{{realm}}.thirdeye.s.finprim.com/login/",
  staging: "https://{{realm}}.thirdeye.d.finprim.com/login/", // TODO Check if this is correct
  qa: "-",
};
export const THIRDEYE_NAVIGATION_URL = thirdeyeNavigationUrlEnvMap[tenantEnv.getEnvironmentName()];
export const VALID_THIRDEYE_ROLES = [
  Role.THIRDEYE_MANAGER,
  Role.THIRDEYE_ANALYST,
  Role.THIRDEYE_OPERATIONS,
  Role.THIRDEYE_SQLLAB,
];

export const VALID_MEMBERSHIP_PORTAL_ROLES = [
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_MEMBERSHIP_OPERATION,
  Role.TENANT_MEMBERSHIP_CHECKER,
  Role.TENANT_MEMBERSHIP_REVIEWER,
  Role.TENANT_MEMBERSHIP_APPROVER,
  Role.TENANT_MEMBERSHIP_MD,
  Role.CYBRILLA_ADMIN,
];

// Home links to unprotected `/`; keep this out of RouteAccessMap and gate the nav item only.
export const FP_CONSOLE_HOME_NAV_ROLES = [
  Role.THIRDEYE_ANALYST,
  Role.THIRDEYE_OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.OPERATIONS,
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS_ANALYST,
];

export const PURCHASE_OVERVIEW_ENABLED_TENANTS = ["cybrillaconsole"];
export const PRODUCT_USAGE_ENABLED_TENANTS = tenantEnv.isProduction
  ? ["hdfcmf", "iprumf", "abslmf", "nipponmf"]
  : ["runway"];

export const V2_PAYMENTS_SUPPORTED_TENANTS = appConfig.app.v2_payments_supported_tenants;

export const MANUAL_BANK_ACCOUNT_VERIFICATION_ENABLED_TENANTS =
  appConfig.app.manual_bank_account_verification_enabled_tenants;

export const PARTNER_CREDENTIALS_ENABLED_TENANTS =
  appConfig.app.partner_credentials_enabled_tenants;

export const POA_TENANTS = appConfig.app.poa_tenants;

export const ONDC_TRANSACTIONS_ENABLED_TENANTS = appConfig.app.ondc_transactions_enabled_tenants;

export const LIMITED_DATA_TABLE_INFO_MESSAGE =
  "Displaying up to 100 records based on your selection.";

export const PRODUCT_DOCS_URL = "https://docs.fintechprimitives.com/";

export const API_LOG_AUTHORISED_ROLES = [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN];

export const PARTNER_EUIN_UPDATE_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.CUSTOMER_SUCCESS,
  Role.OPERATIONS,
];

export const SETTLEMENT_REMEDIATION_MAKER_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_SETTLEMENT_REMEDIATION_MAKER,
];

export const DEPOSIT_RECEIPTS_MANUAL_MIS_UPLOAD_AUTHORISED_ROLES: Role[] = [
  ...SETTLEMENT_REMEDIATION_MAKER_AUTHORISED_ROLES,
  Role.TENANT_SETTLEMENT_ASSOCIATE,
];

export const SETTLEMENT_REPORT_FILES_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_SETTLEMENT_ASSOCIATE,
];

export const SETTLEMENT_REMEDIATION_CHECKER_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_SETTLEMENT_REMEDIATION_CHECKER,
];

export const MIS_REFUND_UPLOAD_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_SETTLEMENT_REMEDIATION_MAKER,
  Role.TENANT_SETTLEMENT_REMEDIATION_CHECKER,
  Role.TENANT_SETTLEMENT_ASSOCIATE,
];

export const MFIA_ORDERS_TAB_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_ROOT,
  Role.TENANT_WORKFORCE,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_INVESTOR,
  Role.TENANT_ORDERS_ANALYST,
];

export const MFIA_INVESTOR_DETAILS_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_ROOT,
  Role.TENANT_WORKFORCE,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_INVESTOR,
  Role.TENANT_INVESTOR_ANALYST,
];

export const MFIA_FOLIO_DEFAULTS_TAB_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_ROOT,
  Role.TENANT_WORKFORCE,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_INVESTOR,
  Role.TENANT_INVESTOR_ANALYST,
];

export const HOLDINGS_TAB_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_ROOT,
  Role.TENANT_WORKFORCE,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_INVESTOR,
];

export const DEMAT_ACCOUNTS_TAB_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_ROOT,
  Role.TENANT_WORKFORCE,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_INVESTOR,
  Role.TEST,
];

export const SOLE_PROPRIETOR_TAB_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_ROOT,
  Role.TENANT_WORKFORCE,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_INVESTOR,
  Role.TEST,
];

export const PAYMENT_TAB_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_ROOT,
  Role.TENANT_WORKFORCE,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_INVESTOR,
];

export const MANDATE_LINK_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_ROOT,
  Role.TENANT_WORKFORCE,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_INVESTOR,
];

export const MFIA_LINK_AUTHORISED_ROLES: Role[] = [
  Role.CUSTOMER_SUCCESS,
  Role.OPERATIONS,
  Role.CYBRILLA_ADMIN,
  Role.TENANT_ROOT,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_WORKFORCE,
  Role.TEST,
  Role.TENANT_INVESTOR_ANALYST,
];

export const SKIP_INSTRUCTIONS_TAB_AUTHORISED_ROLES: Role[] = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
  Role.TENANT_ROOT,
  Role.TENANT_WORKFORCE,
  Role.TENANT_ASSOCIATE_WORKFORCE,
  Role.TENANT_INVESTOR,
];

export const FOLIO_MIGRATION_SWITCH_AUTHORISED_ROLES = [
  Role.CYBRILLA_ADMIN,
  Role.OPERATIONS,
  Role.CUSTOMER_SUCCESS,
];

export const USERTABLE_AUTHORISED_ROLES = [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS];

export const BI_TOOL_ENABLE_DEFAULT_ROLES: Role[] = [
  Role.THIRDEYE_ANALYST,
  Role.THIRDEYE_OPERATIONS,
];

export const USER_MANAGEMENT_ENABLE_DEFAULT_ROLES: Role[] = [Role.TENANT_WORKFORCE];

export const ORDER_OPERATIONS_UPLOAD_FILES_AUTHORISED_ROLES: Role[] = [
  Role.OPERATIONS,
  Role.TENANT_ORDER_OPERATIONS,
  Role.CYBRILLA_ADMIN,
  Role.TENANT_OPERATIONS,
  Role.OPERATIONS_ANALYST,
];

export const ORDER_OPERATIONS_DOWNLOAD_FILES_AUTHORISED_ROLES: Role[] = [
  Role.OPERATIONS,
  Role.TENANT_ORDER_OPERATIONS,
  Role.CYBRILLA_ADMIN,
  Role.TENANT_OPERATIONS,
];

export const FEED_SUBMISSIONS_BULK_ACTIONS_AUTHORISED_ROLES: Role[] = [
  Role.OPERATIONS,
  Role.CYBRILLA_ADMIN,
];

export const ADMIN_ROLES: Role[] = [Role.CYBRILLA_ADMIN];
